import React, { useState, useEffect } from 'react';
import { scroller } from 'react-scroll';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/MASRIQ.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const navItems = [
    { id: 'hero', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'products', label: 'Products' },
    { id: 'ourworks', label: 'Our Works' },
    { id: 'services', label: 'Services' },
    { id: 'quote', label: 'Get a quote' },
    { id: 'careers', label: 'Careers' },
    { id: 'FAQ', label: 'FAQs' },
    { id: 'connect', label: 'Connect' },
  ];

  const location = useLocation();
  const navigate = useNavigate();

  // Helper for section navigation from other routes
  const handleSectionNav = (id) => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: id } });
    } else {
      scroller.scrollTo(id, {
        smooth: true,
        offset: -70,
        duration: 500,
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 z-50 w-full bg-white/10 backdrop-blur-lg border-b border-white/10 shadow-md transition-all duration-300 ${isScrolled ? 'py-2' : 'py-4'}`}>
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 flex items-center justify-between">

        {/* Logo and Brand */}
        <div className="relative group flex items-center gap-2 min-w-[140px] sm:min-w-[160px]">
          <img
            src={logo}
            alt="MASRIQ NextTech Solutions Logo"
            className="h-10 w-10 sm:h-12 sm:w-12 transition-transform duration-300 transform hover:scale-110"
          />
          <span className="text-xl sm:text-2xl font-extrabold bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent whitespace-nowrap">
            MASRIQ
          </span>

          {/* Tooltip for full name */}
          <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 text-xs text-white bg-black/70 px-3 py-1 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-40">
            MASRIQ NextTech Solutions
          </span>
        </div>

        {/* Nav Links */}
        <ul className="hidden lg:flex flex-1 justify-end gap-8 text-white text-base lg:text-lg font-semibold">
          {navItems.map(({ id, label }) => (
            <li key={id} className="whitespace-nowrap">
              <button
                onClick={() => handleSectionNav(id)}
                className="relative inline-block transition duration-300 hover:text-cyan-400 after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-cyan-400 hover:after:w-full after:transition-all after:duration-300 cursor-pointer bg-transparent border-none outline-none"
                style={{ background: 'none', border: 'none', padding: 0 }}
              >
                {label}
              </button>
            </li>
          ))}
          {/* Blogs Page Link */}
          <li className="whitespace-nowrap">
            <RouterLink
              to="/blogs"
              className="relative inline-block transition duration-300 hover:text-cyan-400 after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-cyan-400 hover:after:w-full after:transition-all after:duration-300 cursor-pointer"
            >
              Blogs
            </RouterLink>
          </li>
          {/* Gallery Page Link */}
          <li className="whitespace-nowrap">
            <RouterLink
              to="/gallery"
              className="relative inline-block transition duration-300 hover:text-cyan-400 after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-cyan-400 hover:after:w-full after:transition-all after:duration-300 cursor-pointer"
            >
              Gallery
            </RouterLink>
          </li>
        </ul>

        {/* Mobile Toggle */}
        <div className="lg:hidden text-white text-3xl">
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-white/10 backdrop-blur-lg border-t border-white/10 px-6 py-4 space-y-3">
          {navItems.map(({ id, label }) => (
            <button
              key={id}
              onClick={() => { handleSectionNav(id); setIsOpen(false); }}
              className="block text-white text-base font-semibold py-2 rounded hover:bg-cyan-400/10 transition bg-transparent border-none outline-none"
              style={{ background: 'none', border: 'none', padding: 0 }}
            >
              {label}
            </button>
          ))}
          {/* Blogs Page Link for Mobile */}
          <RouterLink
            to="/blogs"
            onClick={() => setIsOpen(false)}
            className="block text-white text-base font-semibold py-2 rounded hover:bg-cyan-400/10 transition"
          >
            Blogs
          </RouterLink>
          {/* Gallery Page Link for Mobile */}
          <RouterLink
            to="/gallery"
            onClick={() => setIsOpen(false)}
            className="block text-white text-base font-semibold py-2 rounded hover:bg-cyan-400/10 transition"
          >
            Gallery
          </RouterLink>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
